import { useAccount } from "context/AccountContext";
import { useConfig } from "context/ConfigContext";
import { useRef } from "react";

export const useWebmaster = () => {
  const { user } = useAccount();
  const config = useConfig();
  const link = useRef();
  const linkElementId = 'webmaster-edit-link';

  const isAdmin = user?.id === 1;
  const isWebmaster = user?.roles?.indexOf('webmaster') > -1;

  const setEditLink = (id) => {
    const hasEditPermission = isWebmaster || isAdmin;
    if (!hasEditPermission || !id) {
      link.current && link.current.remove();
      return null;
    }

    link.current = document.getElementById(linkElementId);
    if (!link.current) {
      const label = document.createTextNode('Bewerken');
      const a = document.createElement("a");
      a.id = linkElementId;
      a.appendChild(label);
      link.current = a;
      document.body.appendChild(a)
    }
    link.current.href = `${ config.host }/node/${ id }/edit`;
  }

  return { setEditLink };
};
